export default "/wp-content/themes/onnit/script/cart/dist/wheyOverride-c7d6b41a.png";